module.exports = __webpack_public_path__ + "static/img/15.66d1a6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/15.png
// module id = IbBn
// module chunks = 0